module.exports = __webpack_public_path__ + "img/size_2_2.7cdcc1f1.png";